import { useState, useEffect } from "react";
import logger from "../../../../util/logger";

import Swal from "sweetalert2";

import classnames from "classnames";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../../util/firebase";
import {
  query,
  collection,
  getDocs,
  where,
  doc,
  updateDoc,
} from "firebase/firestore";

import { useNavigate } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";

import { useTranslation } from "react-i18next";

function ChangeBannerPage() {
  const { t } = useTranslation("common");

  const [user] = useAuthState(auth);

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const [currentBanner, setCurrentBanner] = useState();
  const fetchUserData = async () => {
    try {
      setIsLoading(true);

      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();

      setCurrentBanner(data.bannerDesktop);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };

  useEffect(() => {
    if (user) {
      fetchUserData();
    }
    // eslint-disable-next-line
  }, [user]);

  // eslint-disable-next-line
  const [banners, setBanners] = useState([
    // {
    //   id: 1,
    //   image: 'https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fbanners%2FdefaultBanner.png?alt=media&token=cbdcd84e-dd77-4d2a-aad9-de558c5058aa',
    //   beneficiaryUids: [
    //     'h47MFghMFtRbiytKhBF08RCY5z12'
    //   ]
    // },
    // {
    //   id: 2,
    //   image: 'https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fbanners%2FdefaultBanner.png?alt=media&token=cbdcd84e-dd77-4d2a-aad9-de558c5058aa',
    //   beneficiaryUids: [
    //     'h47MFghMFtRbiytKhBF08RCY5z12'
    //   ]
    // },
    // {
    //   id: 3,
    //   image: 'https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fbanners%2FdefaultBanner.png?alt=media&token=cbdcd84e-dd77-4d2a-aad9-de558c5058aa',
    //   beneficiaryUids: [
    //     'h47MFghMFtRbiytKhBF08RCY5z12'
    //   ]
    // },
    // {
    //   id: 4,
    //   image: 'https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fbanners%2FdefaultBanner.png?alt=media&token=cbdcd84e-dd77-4d2a-aad9-de558c5058aa',
    //   beneficiaryUids: [
    //     'h47MFghMFtRbiytKhBF08RCY5z12'
    //   ]
    // },
    // {
    //   id: 5,
    //   image: 'https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fbanners%2FdefaultBanner.png?alt=media&token=cbdcd84e-dd77-4d2a-aad9-de558c5058aa',
    //   beneficiaryUids: [
    //   ]
    // },
    // {
    //   id: 6,
    //   image: 'https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fbanners%2FdefaultBanner.png?alt=media&token=cbdcd84e-dd77-4d2a-aad9-de558c5058aa',
    //   beneficiaryUids: [
    //   ]
    // },
    // {
    //   id: 7,
    //   image: 'https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fbanners%2FdefaultBanner.png?alt=media&token=cbdcd84e-dd77-4d2a-aad9-de558c5058aa',
    //   beneficiaryUids: [
    //   ]
    // },
    // {
    //   id: 8,
    //   image: 'https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fbanners%2FdefaultBanner.png?alt=media&token=cbdcd84e-dd77-4d2a-aad9-de558c5058aa',
    //   beneficiaryUids: [
    //   ]
    // },
    // {
    //   id: 9,
    //   image: 'https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fbanners%2FdefaultBanner.png?alt=media&token=cbdcd84e-dd77-4d2a-aad9-de558c5058aa',
    //   beneficiaryUids: [
    //   ]
    // }
  ]);

  const [bannerCategories, setBannerCategories] = useState();

  const fetchBanners = async () => {
    try {
      setIsLoading(true);

      let fetchedBanners = [];
      let fetchedBannerCategories = [];

      const q = query(collection(db, "banners"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newBanner = doc.data();
        if (!fetchedBannerCategories.includes(newBanner.category)) {
          fetchedBannerCategories.push(newBanner.category);
        }
        fetchedBanners.push(newBanner);
      });

      setBanners(fetchedBanners);
      setBannerCategories(fetchedBannerCategories);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching banners");
    }
  };
  useEffect(() => {
    if (user) {
      fetchBanners();
    }
    // eslint-disable-next-line
  }, [user]);

  const changeBanner = async (banner) => {
    logger.debug(banner);
    Swal.fire({
      text: "Are you sure you want to change your banner?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, I'M SURE",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        try {
          const userRef = query(
            collection(db, "users"),
            where("uid", "==", user?.uid)
          );
          const findUsers = await getDocs(userRef);
          findUsers.forEach(async (userObject) => {
            const getUser = doc(db, "users", userObject.id);
            await updateDoc(getUser, {
              bannerDesktop: banner.imageMobile,
              bannerMobile: banner.imageMobile,
            });
          });

          fetchUserData();

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          alert(err.message);

          setIsLoading(false);
        }
      }
    });
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="changeBannerPage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        {t("changeBanner").toUpperCase()}
      </h1>
      {bannerCategories?.map((category) => {
        return (
          <div style={{ marginBottom: "1rem" }}>
            <p className="assetCategoryHeader">{category?.toUpperCase()}</p>
            <div>
              {
                // eslint-disable-next-line
                banners?.map((banner) => {
                  if (banner.category === category) {
                    return (
                      <div
                        onClick={() =>
                          banner.imageMobile !== currentBanner &&
                          (!banner.isPremium ||
                            (banner.isPremium &&
                              banner.beneficiaryUids?.includes(user.uid)))
                            ? changeBanner(banner)
                            : null
                        }
                        className={classnames(
                          "bannerPageBanner",
                          {
                            locked:
                              banner.isPremium === true &&
                              banner.beneficiaryUids &&
                              !banner.beneficiaryUids?.includes(user.uid),
                          },
                          {
                            active: banner.imageMobile === currentBanner,
                          }
                        )}
                      >
                        <img
                          alt="bannerImage"
                          src={banner.imageDesktop}
                          className="hideOnMobile"
                        />
                        <img
                          alt="bannerImage"
                          src={banner.imageMobile}
                          className="hideOnDesktop"
                        />
                      </div>
                    );
                  }
                })
              }
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default ChangeBannerPage;
